import { render, staticRenderFns } from "./UsedWords.vue?vue&type=template&id=703526c2&scoped=true"
import script from "./UsedWords.vue?vue&type=script&lang=js"
export * from "./UsedWords.vue?vue&type=script&lang=js"
import style0 from "./UsedWords.vue?vue&type=style&index=0&id=703526c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703526c2",
  null
  
)

export default component.exports